import { useRef } from 'react';
import type { ReactNode } from 'react';

import { Transition } from 'react-transition-group';

import { Wrapper } from './styled';

export interface Props {
  open: boolean;
  minHeight: number;
  animationDuration?: number;
  children: ReactNode;
}

export const Truncator = ({
  open,
  minHeight,
  animationDuration = 0.5,
  children,
}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  return (
    <Transition
      in={open}
      timeout={{
        enter: animationDuration * 1000,
        exit: 50,
      }}
    >
      {(state) => {
        return (
          <Wrapper
            data-state={state}
            minHeight={minHeight}
            maxHeight={ref.current ? ref.current.offsetHeight : minHeight}
            animationDuration={animationDuration}
          >
            <div ref={ref}>{children}</div>
          </Wrapper>
        );
      }}
    </Transition>
  );
};
